import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpLoadingComponent } from './shared/loading/http-loading/http-loading.component';
import { BaseComponent } from './views/layout/base/base.component';
import { NavbarComponent } from './views/layout/navbar/navbar.component';
import { SidebarComponent } from './views/layout/sidebar/sidebar.component';
import { FooterComponent } from './views/layout/footer/footer.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, HttpLoadingComponent, BaseComponent, NavbarComponent, SidebarComponent, FooterComponent]
})
export class AppComponent implements OnInit {
  title = 'nobleui-angular';

  ngOnInit(): void {}
}